<template>
	<div>
		<minhead :headtitle="jtgstitle"></minhead>
		<el-dialog :title="jttitle" :visible.sync="openaddgroup"  width="600px" :close-on-click-modal="false" v-dialogDrag>
			<el-form :model="groupform" ref="groupformRules" :rules="groupformRules">
				<el-form-item label="集团名称" prop="name" label-width="120px"><el-input v-model="groupform.name" autocomplete="off" maxlength="100" style="width: 300px;"></el-input></el-form-item>
				<el-form-item label="集团编号" prop="code" label-width="120px"><el-input v-model="groupform.code" autocomplete="off" maxlength="50" style="width: 300px;"></el-input></el-form-item>
				<el-form-item label="当前状态" prop="state" label-width="120px">
					<el-select v-model="groupform.state" placeholder="请选择当前状态" style="width: 300px;">
						<el-option label="正常" value="0"></el-option>
						<el-option label="停用" value="1"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="集团唯一ID" prop="jungleadGroupId" label-width="120px"><el-input v-model="groupform.jungleadGroupId" autocomplete="off" maxlength="50" style="width: 300px;"></el-input></el-form-item>
			</el-form> 
			<div slot="footer" class="dialog-footer">
				<el-button @click="openaddgroup = false" style="font-size: 14px">取 消</el-button>
				<el-button  type="primary" @click="submitForm('ruleForm')" style="font-size: 14px">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="xftitle" :visible.sync="openaddseller" width="800px" :close-on-click-modal="false" v-dialogDrag>
			<el-form :model="SellerForm" ref="ruleForm" :disabled="!companyDisabled" label-width="100px" class="demo-ruleForm" :rules="rules">
				<div class="toptitle">基本信息</div>
				<div style="display: flex;">
					<el-form-item label="企业编号" prop="code"><el-input :disabled="!openDisabled" v-model="SellerForm.code" maxlength="20"></el-input></el-form-item>
					<el-form-item label="公司代码" prop="qiybh"><el-input :disabled="!openDisabled" v-model="SellerForm.qiybh" maxlength="4"></el-input></el-form-item>
				</div>
				<div style="display: flex;">
					<el-form-item label="销方税号" prop="taxNumber"><el-input v-model="SellerForm.taxNumber" maxlength="20"></el-input></el-form-item>
					<el-form-item label="销方名称" prop="name"><el-input v-model="SellerForm.name"></el-input></el-form-item>
				</div>
				<div style="display: flex;">
					<el-form-item label="是否启用" prop="state">
						<el-select v-model="SellerForm.state" placeholder="请选择是否启用" style="width: 200px;">
							<el-option label="正常" value="0"></el-option>
							<el-option label="停用" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="授权密钥" prop="authKey"><el-input v-model="SellerForm.authKey"></el-input></el-form-item>
				</div>
				<div style="display: flex;">
					<el-form-item label="所属集团" prop="SellergroupName"><el-input disabled="disabled" v-model="SellergroupName"></el-input></el-form-item>
					<el-form-item label="集团编号" prop="SellergroupCode"><el-input disabled="disabled" v-model="SellergroupCode"></el-input></el-form-item>
				</div>

				<div class="toptitle">详细信息</div>
				<el-form-item label="银行,账号" prop="bankAccount"><el-input v-model="SellerForm.bankAccount"></el-input></el-form-item>
				<el-form-item label="地址,电话" prop="addressPhone"><el-input v-model="SellerForm.addressPhone"></el-input></el-form-item>
				<div class="toptitle">联系人</div>
				<div style="display: flex;">
					<el-form-item label="姓名" prop="contact"><el-input v-model="SellerForm.contact"></el-input></el-form-item>
					<el-form-item label="手机" prop="phoneNumber"><el-input v-model="SellerForm.phoneNumber"></el-input></el-form-item>
				</div>
				<div style="display: flex;">
					<el-form-item label="邮箱" prop="email"><el-input v-model="SellerForm.email"></el-input></el-form-item>
					<!--<el-form-item label="开票类型" prop="billingMethod">
						<el-select v-model="SellerForm.billingMethod" placeholder="请选择开票类型">
							<el-option label="pc端显示" value="1"></el-option>
							<el-option label="手机端显示" value="0"></el-option>
						</el-select>
					</el-form-item>-->
				   
				</div>
			</el-form>
			<div slot="footer" style="margin-top: -30px;">
				<el-button @click="openaddseller = false">取 消</el-button>
				<el-button type="primary" @click="addcomm('ruleForm')" v-if="xftitle != '查看销方公司'">确 定</el-button>
			</div>
		</el-dialog>
		<div class="contextall">
			<div>
				<div class="Centerupdown">
					<!-- <el-button type="primary" plain @click="foraddjt('新建集团')">新建集团</el-button> -->
					<div class="addstyle" style="width: 80px; margin-right: 10px;"  @click="foraddjt('新建集团')">
							<samp>
					新建集团
							</samp>
						</div>
					<!-- <el-button type="danger" plain @click="fordelete">删除集团</el-button> -->
					<div class="dangestyle" style="width: 80px; margin-right: 10px;"  @click="fordelete">
							<samp>
					删除集团
							</samp>
						</div>
                    <!-- <el-button type="danger" plain @click="syncJungleadCompanyId">同步企业全局ID</el-button> -->
					<div class="dangestyle" style="width: 120px; margin-right: 10px;"  @click="syncJungleadCompanyId">
							<samp>
					同步企业全局ID
							</samp>
						</div>
				</div>
				<div class="halfactive">
					<el-breadcrumb-item>集团公司</el-breadcrumb-item>
					<el-input v-model="likeSearchvalue" prefix-icon="el-icon-search" clearable placeholder="搜索所属集团名称和编号" style="width: 250px;" @input="forserchgroup"></el-input>
				</div>
				<div class="bottomhalf">
					<el-table    :data="tableData" border  style="width: 100%;">
						<el-table-column  width="120"  label="序号">
							<template slot-scope="scope">
								<el-radio v-model="radio" :label="scope.$index + 1" @change="radiochange(scope.row)"></el-radio>
							</template>
						</el-table-column>
						<el-table-column  prop="name" label="集团名称" width="140"></el-table-column>
						<el-table-column prop="code" label="集团编号" width="150" ></el-table-column>
						<el-table-column prop="state" label="状态" width="140"  align="" :formatter="stateFormat"></el-table-column>

						<el-table-column fixed="right" label="操作" width="140">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="forupdata('编辑集团公司', scope.row)">编辑</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 30, 100]"
						:page-size="pagenum"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
			<div>
				<div class="Centerupdown">
					<!-- <el-button type="primary" plain @click="foraddxiaofang('新建销方公司')">新建销方公司</el-button> -->
					<div class="addstyle" style="width: 100px;margin-right: 14px;"@click="foraddxiaofang('新建销方公司')">新建销方公司
					</div>
					<!-- <el-button type="danger" plain @click="fordeletecommy">删除销方公司</el-button> -->
					<div class="dangestyle" style="width: 120px; margin-right: 10px;"  @click="fordeletecommy">
							<samp>
					删除销方公司
							</samp>
						</div>
				</div>
				<div class="halfactive">
					<el-breadcrumb-item>销方名称</el-breadcrumb-item>
					<el-input prefix-icon="el-icon-search" v-model="likeSearchCompany" placeholder="搜索所属集团名称和编号" style="width: 250px;" @input="forchangecomm"></el-input>
				</div>
				<div class="bottomhalf">
					<div class="tableh">
					<el-table :data="commdata" style="width: 100%" @selection-change="changeselection" :height="tableHeight" ref="multipleTable">
						<el-table-column type="selection" width="55" ></el-table-column>
						<el-table-column prop="name" label="销方名称" width="120" ></el-table-column>
						<el-table-column prop="taxNumber" label="销方税号" width="120" ></el-table-column>
						<el-table-column prop="newstate" label="公司状态" show-overflow-tooltip width="100" ></el-table-column>
						<el-table-column prop="contact" label="联系人" show-overflow-tooltip ></el-table-column>
						<el-table-column prop="phoneNumber" label="手机号" show-overflow-tooltip ></el-table-column>
						<el-table-column fixed="right" label="操作" width="100">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="forselect(scope.row, '查看销方公司')">查看</el-button>
								<el-button type="text" size="small" @click="forupdate(scope.row, '编辑销方公司')">编辑</el-button>
							</template>
						</el-table-column>
					</el-table>
					</div>
					<el-pagination
						@size-change="handleSizeChangecompy"
						@current-change="handleCurrentChangecompy"
						:page-sizes="[10, 20, 30, 100]"
						:page-size="10"
						layout="total, sizes, prev, pager, next, jumper"
						:total="comontotalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: '',
	data() {
		var verifPhoneNumber = (rule, value, callback) => {
			var reg = /^1[0-9]{10}$/gi;//
			if (!reg.test(value)&&value) {
				callback(new Error('请输入正确手机号'));
			}else {
				callback();
			}
		};
		var validateNasrsbhInfo = (rule, value, callback) => {
			var reg = /^[A-z0-9]+$/gi; //
			if (!reg.test(value)) {
				callback(new Error('只能输入15,18,20长度的字母和数字'));
			} else {
				if( value.length=='15' || value.length =='18'  || value.length =='20'){
					callback();
				}else{
					callback(new Error('只能输入15,18,20长度的字母和数字'));
				}
			}
		};
		return {

			jtgstitle:['系统设置', '集团成员公司'],
			xftitle: '',
			jttitle: '',
			groupformRules:{
				name:{required: true, message: '请输入集团名称', trigger: 'blur'},
				code:{required: true, message: '请输入集团编号', trigger: 'blur'},
				state:{required: true, message: '请选择集团状态', trigger: 'blur'},
                jungleadGroupId:{required: true, message: '请输入集团唯一ID', trigger: 'blur'}
			},
			rules: {
				name: [
					{ required: true, message: '请输入销方名称', trigger: 'blur' },
				],
				state: [{ required: true, message: '请选择启用状态', trigger: 'blur' }],
				taxNumber: [
					{validator:validateNasrsbhInfo,trigger:'blur',required: true}
					],
				authKey: [{ required: true, message: '请输入授权密钥', trigger: 'blur' }],
				contact: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				phoneNumber: [{validator:verifPhoneNumber,trigger:'blur'}],
				/*billingMethod: [{ required: true, message: '请选择开票类型', trigger: 'blur' }],*/
				code: [{ required: true, message: '请输入企业编号', trigger: 'blur' }],
				qiybh:[{ required: true, message: '请输入公司编号', trigger: 'blur' }],
				bankAccount: [
					{ required: true, message: '请输入银行，账号', trigger: 'blur' },
					{ max: 100, message: '长度不能超过100个字符', trigger: 'blur' }
					],
				addressPhone: [
					{ required: true, message: '请输入地址，电话', trigger: 'blur' },
					{ max: 100, message: '长度不能超过100个字符', trigger: 'blur' }
					],
			},
			SellerForm: {
				name: '', //消防名称
				state: '', //0禁用，1,启用
				taxNumber: '', //销方税号
				authKey: '', //授权密钥

				groupId: '', //所属集团，集团编号
				code:'',//企业编号
				bankAccount: '', //""//银行账号
				addressPhone: '', //地址电话
				contact: '', //姓名
				phoneNumber: '', //手机号
				email: '' ,//邮箱
				/*billingMethod:'', //开票类型*/
				updateTime : '',
				version : '',
				createTime : ''
				
			},
			SellergroupName: '',
			SellergroupCode: '',
			openaddseller: false,
			openaddgroup: false,
			radio: 0,
			commdata: [],

			CompanyGroupList: [],

			// 分页
			ids: '',
			totalcount: '',
			comontotalcount: '',
			page: 1,
			pagenum: 10,
			pageCompany: 1,
			pagenumCompany: 10,
			tableData: [],
			choosejtid: '',
			groupform: {
				name: '',
				code: '',
				state: '',
                jungleadGroupId:''
			},
			deleteids: '',//集团选中id
			deletecommids: '',//公司选中删除id
			likeSearchvalue: '',
			likeSearchCompany: '',
			companyDisabled:false,
			openDisabled:false,
			tableHeight:""
		};
	},
	created() {
		this.getCompanyGroupList();
	},
	mounted() {
		 this.$nextTick(() =>{
			this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
			window.onresize = () =>{
		    this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
		      }
		    })
	},

	methods: {
		handleSizeChange(val) {
			this.pagenum = val;
			this.getCompanyGroupList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getCompanyGroupList();
		},
		handleSizeChangecompy(val) {
			this.pagenumCompany = val;
			this.getCompanyList(this.deleteids);
		},
		handleCurrentChangecompy(val) {
			this.pageCompany = val;
			this.getCompanyList(this.deleteids);
		},
		/* 公司多选 */
		changeselection(e) {
			console.log(e);
			this.deletecommids = '';
			e.forEach((item, index) => {
				this.deletecommids = this.deletecommids + item.id + ',';
			});
			var reg = /,$/gi;
			this.deletecommids = this.deletecommids.replace(reg, '');
			console.log(this.deletecommids);
		},

		/* 	编辑弹出 */
		forupdate(e, f) {
			this.openCompanyGroup(e,f, true);
		},

		/* 	查看弹出 */
		forselect(e, f) {
			this.openCompanyGroup(e, f, false);
		},
		openCompanyGroup(e,f,state){
			this.xftitle = f;
			this.SellerForm.name = e.name;
			this.SellerForm.state = e.state;
			this.SellerForm.taxNumber = e.taxNumber;
			this.SellerForm.authKey = e.authKey;
			this.SellerForm.groupId = this.deleteids;
			this.SellerForm.bankAccount = e.bankAccount;
			this.SellerForm.addressPhone = e.addressPhone;
			this.SellerForm.contact = e.contact;
			this.SellerForm.code = e.code;
			this.SellerForm.phoneNumber = e.phoneNumber;
			this.SellerForm.email = e.email;
			this.SellerForm.id = e.id;
			this.openaddseller = true;
			this.SellerForm.updateTime = e.updateTime;
			this.SellerForm.version = e.version;
			this.SellerForm.createTime = e.createTime;
			this.companyDisabled=state;
			this.openDisabled=false;
		},

		/* 新增公司弹出 */
		foraddxiaofang(e) {
			if (this.deleteids == '') {
				 this.$message.error("请先选择集团")
				return false;
			}
			Object.keys(this.SellerForm).map(key => (this.SellerForm[key] = ''));
			this.openaddseller = true;
			this.xftitle = e;
			this.SellerForm.taxNumber = e.taxNumber;
			this.companyDisabled=true;
			this.openDisabled=true;
		},
		/* 提交新增公司 */
		addcomm(e) {
			this.$refs[e].validate(valid => {
				if (valid) {
					if ((this.xftitle == '编辑销方公司')) {
						this.updateCompany(this.SellerForm);
					} else if ((this.xftitle == '新建销方公司')) {
						this.addCompany(this.SellerForm);
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		/* 	多选删除公司 */
		fordeletecommy() {
			if (this.deletecommids == '') {
				 this.$message.error("请选择要删除的公司")
				return false;
			}
			this.$confirm('此操作将删除该公司, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.deleteCompanys(this.deletecommids);
				})
				.catch(() => {
					 this.$message.info("已取消删除")
				});
		},
		/* 搜索公司 */
		forchangecomm() {
			this.getCompanyList(this.deleteids);
		},
		/* 选择集团 */
		radiochange(val) {
			this.deleteids = val.id;
			console.log(val);
			this.getCompanyList(val.id);
			this.SellergroupName = val.name;
			this.SellergroupCode = val.code;
		},
		/* 	编辑集团公司弹出	 */
		forupdata(e, obj) {
			this.jttitle = e;
			this.openaddgroup = true;
			this.choosejtid = obj.id;
			this.groupform.name = obj.name;
			this.groupform.code = obj.code;
			this.groupform.state = obj.state;
			this.groupform.updateTime = obj.updateTime;
			this.groupform.version = obj.version;
			this.groupform.createTime = obj.createTime;
		},
		/* 删除集团点击 */
		fordelete() {
			if (this.deleteids == '') {
				 this.$message.error("请选择要删除的集团")
				return false;
			}
			this.$confirm('此操作将删除该集团, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.deleteCompanyGroups(this.deleteids);
				})
				.catch(() => {
					this.$message.info("已取消删除")
				});
		},
		/* 集团列表搜索 */

		forserchgroup() {
			this.getCompanyGroupList();
		},
        syncJungleadCompanyId(){
            this.$https.fetchPost("sys/admin/syncJungleadCompanyId").then(res=>{
                // console.log(res);
                // if (res.success){
                //     this.$message.info(res.message);
                // } else {
                //     this.$message.error(res.message);
                // }
            })
        },
		/* 	新增集团弹出 */
		foraddjt(e) {
			Object.keys(this.groupform).map(key => (this.groupform[key] = ''));
			this.openaddgroup = true;
			this.jttitle = e;
		},
		/* 新增，编辑集团提交 */
		submitForm() {
			this.$refs['groupformRules'].validate(valid => {
				if (valid){
					if (this.jttitle == '新建集团') {
						this.addCompanyGroup(this.groupform);
					} else if (this.jttitle == '编辑集团公司') {
						if (this.choosejtid == '') {
							return false;
						}
						this.updateCompanyGroup(this.groupform, this.choosejtid);
					}
				}
			});

		},

		/* 	接口调用操作 */
		/* 多选删除公司 */
		deleteCompanys(ids) {
			let params = ids;
			this.$https.fetchPost('sys/admin/deleteCompanys', params).then(res => {
				if (res.data.success) {
					this.getCompanyList(this.deleteids);
				}
			});
		},

		/* 新增公司 */
		addCompany(e) {
			let params = e;
			params.groupId = this.deleteids;
			this.$https.fetchPost('sys/admin/addCompany', params).then(res => {
				if (res.data.success) {
					this.openaddseller = false;
					this.getCompanyList(this.deleteids);
				}
			});
		},
	

		// 新建集团
		addCompanyGroup(e) {
			let params = e;
			params = e;
			this.$https.fetchPost('sys/admin/addCompanyGroup', params).then(res => {
				if (res.data.success) {
					this.openaddgroup = false;
					this.getCompanyGroupList();
				}
			});
		},
		// 根据集团找公司
		getCompanyList(e) {
			let id = e;
			if (id == '') {
				id = null;
			}
			let params = {
				search: { groupId: id },
				likeSearch: this.likeSearchCompany,
				page: this.pageCompany,
				limit: this.pagenumCompany
			};
			this.$https.fetchPost('sys/admin/getCompanyList', params).then(res => {
				this.commdata = res.data.data;
				this.comontotalcount = res.data.count;
				console.log(res.data.data)
				this.commdata.forEach(item => {
					item.newstate = this.statbacketostring(item.state);
				});
				console.log(this.commdata)
			});
		},
		// 编辑集团
		updateCompanyGroup(e, id) {
			let params = e;
			params = e;
			params.id = id;
			this.$https.fetchPost('sys/admin/updateCompanyGroup', params).then(res => {
				if (res.data.success) {
					this.openaddgroup = false;
					this.getCompanyGroupList();
				}
			});
		},
		// 编辑公司
		updateCompany(e) {
			let params = e;

			this.$https.fetchPost('sys/admin/updateCompany', params).then(res => {
				if (res.data.success) {
					this.openaddseller = false;
					this.getCompanyList(this.deleteids);
				}
			});
		},
		// 删除集团
		deleteCompanyGroups(id) {
			let ids = id.toString();
			let params = ids;

			this.$https.fetchPost('sys/admin/deleteCompanyGroups', params).then(res => {
				if (res.data.success) {
					this.openaddgroup = false;
					this.deleteids=""
					this.radio=""
					this.deletecommids=""
					this.likeSearchvalue=""
					this.getCompanyGroupList();
				}
			});
		},
		// 获取集团列表
		getCompanyGroupList() {
			let params = {
				likeSearch: this.likeSearchvalue,
				page: this.page,
				limit: this.pagenum
			};
			this.$https.fetchPost('sys/admin/getCompanyGroupList', params).then(res => {
				console.log(res);
				this.totalcount = res.data.count;
				this.tableData = res.data.data;
				this.tableData.forEach(item => {
					item.newstate = this.statbacketostring(item.state);
				});
				console.log(this.tableData);
			});
		},
		stateFormat(row, column, cellValue, index) {
			console.log(row);
			if (row.state == "0") {
				return "正常";
			} else if (row.state == "1") {
				return "停用";
			}else{
				return row.state;
			}
		},
		invalidSerchForm(type) {
			switch (type) {
				case "qiybh":
					this.jibenform.qiybh = this.jibenform.qiybh.replace(/[^\da-zA-Z]/g, '');
					break;
				case "taxNumber":
					this.jibenform.taxNumber = this.jibenform.taxNumber.replace(/[^\da-zA-Z]/g, '');
					break;
			}
			this.jibenform.code = this.jibenform.taxNumber+""+this.jibenform.qiybh;
			this.jibenform.code=this.jibenform.code.replace('undefined', '');
		}
	}
};
</script>

<style scoped="scoped">
	
	/deep/.el-table--small td {
	    padding: 4px 0;
	}
	/deep/.el-table__body-wrapper {
		min-height: 250px;
	}
.toptitle {
	margin-bottom: 20px;
}
.bottomhalf {
	margin-top: 20px;
	border: 1px solid #e6e6e6;
}
.contextall {
	display: flex;
	margin-left: 21px;
}

.halfactive {
	display: flex;
	align-items: center;
	font-size: 14px;
	justify-content: space-between;
}
.contextall > div {
	width: 48%;
}
.contextall > div:nth-of-type(2) {
	margin-left: 4%;
}
/* 	/deep/.el-input__inner{
		border-radius:24px;
	} */
</style>
